import React from 'react';

export default function TaglineSection() {
  return (
    <section className="py-12 md:py-16 bg-[#f7f7f9]">
      <div className="zh-container">
        {/* Italic tagline */}
        <p
          className="text-center text-gray-900 text-xl md:text-2xl leading-relaxed max-w-4xl mx-auto mb-10 md:mb-14"
          style={{ fontFamily: "'Georgia', 'Times New Roman', serif", fontStyle: 'italic' }}
        >
          Built to remove complexity and help people move forward with clarity.
        </p>

        {/* Bracketed wordmark */}
        <div className="relative max-w-3xl mx-auto py-10 md:py-12">
          {/* Corner brackets */}
          <span
            aria-hidden="true"
            className="absolute top-0 left-0 w-10 h-10"
            style={{
              borderTop: '2px solid #f5a623',
              borderLeft: '2px solid #f5a623',
            }}
          />
          <span
            aria-hidden="true"
            className="absolute top-0 right-0 w-10 h-10"
            style={{
              borderTop: '2px solid #f5a623',
              borderRight: '2px solid #f5a623',
            }}
          />
          <span
            aria-hidden="true"
            className="absolute bottom-0 left-0 w-10 h-10"
            style={{
              borderBottom: '2px solid #f5a623',
              borderLeft: '2px solid #f5a623',
            }}
          />
          <span
            aria-hidden="true"
            className="absolute bottom-0 right-0 w-10 h-10"
            style={{
              borderBottom: '2px solid #f5a623',
              borderRight: '2px solid #f5a623',
            }}
          />

          {/* Divider line */}
          <div className="h-px bg-gray-300 w-3/4 mx-auto mb-7" />

          {/* Wordmark */}
          <div className="text-center">
            <span className="text-2xl md:text-3xl font-extrabold tracking-[0.35em] text-gray-900">
              ZHELTA
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
